import { render } from "./addBilling.vue?vue&type=template&id=1efa4812"
import script from "./addBilling.vue?vue&type=script&lang=js"
export * from "./addBilling.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__